'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var normalizePercent = exports.normalizePercent = function normalizePercent(value) {
  var numString = value.replace(/\D/g, '');

  var parsedNumber = numString ? Number(numString) : null;

  if (typeof parsedNumber === 'number') {
    if (parsedNumber > 100) {
      return 1;
    }
    return parsedNumber / 100;
  }
  return parsedNumber;
};

// https://redux-form.com/6.0.0-rc.3/examples/normalizing/
var normalizePhone = exports.normalizePhone = function normalizePhone(value) {
  if (!value) {
    return value;
  }

  var onlyNums = value.replace(/[^\d]/g, '');
  if (onlyNums.length <= 3) {
    return onlyNums;
  }
  if (onlyNums.length <= 7) {
    return onlyNums.slice(0, 3) + '-' + onlyNums.slice(3);
  }
  return onlyNums.slice(0, 3) + '-' + onlyNums.slice(3, 6) + '-' + onlyNums.slice(6, 10);
};